import url from "/vercel/path0/src/pages/ReportingAndDocuments/imgs/pdf.svg?url";
export default url;
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPdf = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 73,
	height: 72,
	viewBox: "0 0 73 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M60.832 6H24.832C21.532 6 18.832 8.7 18.832 12V48C18.832 51.3 21.532 54 24.832 54H60.832C64.132 54 66.832 51.3 66.832 48V12C66.832 8.7 64.132 6 60.832 6ZM60.832 48H24.832V12H60.832V48ZM12.832 18H6.83203V60C6.83203 63.3 9.53203 66 12.832 66H54.832V60H12.832V18ZM48.832 36V27C48.832 25.35 47.482 24 45.832 24H39.832V39H45.832C47.482 39 48.832 37.65 48.832 36ZM42.832 27H45.832V36H42.832V27ZM54.832 33H57.832V30H54.832V27H57.832V24H51.832V39H54.832V33ZM30.832 33H33.832C35.482 33 36.832 31.65 36.832 30V27C36.832 25.35 35.482 24 33.832 24H27.832V39H30.832V33ZM30.832 27H33.832V30H30.832V27Z",
		fill: "#0089BD"
	})]
});
const ForwardRef = forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
